/**************
 Product Swiper
 **************/

const productSection = document.querySelector('#product');

// thumbnail swiper
const thumbSwiper = new Swiper('.productVisualThumbnailsSwiper', {
    slidesPerView: 5,
    spaceBetween: 12,
});

// main swiper
const productSwiper = new Swiper('.productVisualSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    thumbs: {
        swiper: thumbSwiper
    },
});

/****************
 Product Variants
 ***************/

// select change on sticky ATC
document.querySelector('#productStickyBuyingSelect')?.addEventListener('change', function () {
    document.querySelector(`.productOptionItemValuesLabel input[value="${this.options[this.selectedIndex].textContent}"]`).click();
});

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        inputChanges(element);
    });
})

// update active variant
function updateProduct(soldOut = false) {

    if (product.variants.length > 1) {
        // collect options from inputs
        let options = [];
        document.querySelectorAll(`.productOptionItem`).forEach(group => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // update variant title
    if (document.querySelector('.productVariantTitle')) document.querySelector('.productVariantTitle').textContent = activeVariant.title;

    // update variant description
    document.querySelector('.productUniqueDescription.active')?.classList.remove('active');
    document.querySelector(`.productUniqueDescription[data-name="${activeVariant?.title}"]`)?.classList.add('active');

    // update sticky ATC to same variant
    if (document.querySelector('#productStickyBuyingSelect')) {
        document.querySelector('#productStickyBuyingSelect').value = activeVariant?.id;
        document.querySelector('.productStickyTitle.active')?.classList.remove('active');
        document.querySelector(`.productStickyTitle[data-id="${activeVariant?.id}"]`).classList.add('active');

    }

    // ships on
    document.querySelectorAll(`#productShipsOn span`).forEach(el => el.classList.remove('active'));
    document.querySelector(`#productShipsOn [data-id="${activeVariant?.id}"]`)?.classList.add('active');

    // update url with variant id so the selected options are maintained on refresh
    if (activeVariant?.id) {
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant?.id);
        window.history.replaceState({}, "", url);
    }
}

// If on a page, update the active variant to mimic the product page
if (document.querySelector('#product').classList.contains('page')) {
    const pageLink = String(window.location.href);
    if (pageLink.includes("variant")) {
        const id = pageLink.split("variant=")[1];
        if (document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"]`)) {
            document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"] input`).checked = true;
            inputChanges(document.querySelector(`.productOptionItemValuesLabel[data-id="${id}"] input`))
        }
    }
} else {
    updateProduct();
}

function inputChanges(element) {
    element.closest('.productOptionItem')?.querySelectorAll('label.active').forEach(el => {
        el.classList.remove("active");
        el.style.backgroundColor = "transparent";
    });

    // change label to active
    element.closest('label').classList.add("active");
    const color = element.closest('label').dataset.color;
    element.closest('label').style.backgroundColor = `${color}`;
    // change extra points background color, if available
    document.querySelectorAll('.productSubscriptionPointsListItem').forEach(el => {
        el.style.backgroundColor = `${color}`;
        // for max-holloway //
        color === "#b53c34" ? el.style.color = "#fff" : el.style.color = "#000";
    })

    // check if marked sold out via metafield
    let soldOut = element.classList.contains('soldOut');
    updateProduct(soldOut);
}

/**********************
 * Product Subscription
 **********************/

let hasSubscription = !!document.querySelector('#productSubscription');
let subscriptionID = document.querySelector("#productSubscription")?.dataset.subscription;
const subscriptionPrice = document.querySelector("#productSubscription .productBuyingPrice");

// changing from OTP to Subscription
document.querySelectorAll('.productBuyingOption').forEach(el => {
    el.addEventListener('click', function () {
        // handle active
        if (this.classList.contains('active')) return;
        this.closest('#productBuying').querySelector('.productBuyingOption.active')?.classList.remove('active');
        this.classList.add('active');

        // clicking either option resets subscription ID and if one-time is selected subscription is false
        if (this.id === "productOnce") {
            hasSubscription = false;
            document.querySelector('#productShippingDetailsContainer').classList.remove('active');
        } else {
            hasSubscription = true;
            document.querySelector('#productShippingDetailsContainer').classList.add('active');
        }
    })
})

/******************
 * Product Quantity
 ******************/

let quantity = 1;

// opens read the label modal
document.querySelector('.productLabelButton')?.addEventListener('click', () => {
    document.querySelector('#productLabelDialog').showModal();
    document.querySelector('body').classList.add('noScroll');
});

// closes read the label modal
function closeProductModal() {
    document.querySelector('#productLabelDialog').close();
    document.querySelector('body').classList.remove('noScroll');
}

document.querySelector('#productLabelDialogExit')?.addEventListener('click', () => {
    closeProductModal()
});

document.querySelector('#productLabelDialog')?.addEventListener('click', function (e) {
    if (e.target === this) {
        closeProductModal()
    }
});

document.querySelector('#productLabelDialog')?.addEventListener('close', () => {
    document.querySelector('body').classList.remove('noScroll');
});

// check if discount code is present
if (Cookies.get("discount_code")) {
    // set the discount code text
    document.querySelector("#couponfield").textContent = `${Cookies.get("discount_code").toUpperCase()} applied at checkout`;

    // show the discount code element
    document.querySelector("#couponfield").classList.add("active");
}


// scroll to reviews - allow time for page to load
setTimeout(() => {
    document.querySelector('#productReview').addEventListener('click', () => {
        const reviewSection = document.querySelector('.junip-product-review') || document.querySelector('.junip-review-section');
        if (reviewSection) {
            scrollUntilVisible(reviewSection);
        }
    })
}, 2000)
